export const useDownload = () => {
  const downloadBlob = (blob: Blob, name: string) => {
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = name;
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
  };

  const getFileName = (response: Response): string | null => {
    const disposition = response.headers.get("Content-Disposition");
    if (disposition && disposition.indexOf("attachment") !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches?.[1]) {
        return matches[1].replace(/['"]/g, "");
      }
    }
    return null;
  };

  const fetchFileAndDownload = async (url: string) => {
    const response = await fetch(url, {
      method: "GET",
      credentials: "same-origin",
    });

    if (!response.ok) return;
    const contentType = response.headers.get("Content-Type");
    const fileName = getFileName(response);

    if (!contentType) return;

    // Blob keeps the UTF-8 BOM; response.text() drops it and Excel mis-detects encoding.
    if (contentType.includes("text/csv")) {
      const data = await response.blob();
      downloadBlob(data, fileName ?? "File.csv");
    }

    if (contentType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      const data = await response.blob();
      downloadBlob(data, fileName ?? "File.xlsx");
    }
  };

  return { fetchFileAndDownload, downloadBlob };
};
